import request from '@/router/axios'
import env from '@/config/env'

/**
 * 添加角色
 */
export const addRole = (sysRole) => {
  return request({
    url: env.ferryUrl + '/role/save',
    method: 'POST',
    data: sysRole
  })
}
export const addRoleV2 = (sysRole) => {
  return request({
    url: env.ferryUrl + '/role/v2/save',
    method: 'POST',
    data: sysRole
  })
}

/**
 * 修改角色
 */
export const updateRole = (sysRole) => {
  return request({
    url: env.ferryUrl + '/role/update',
    method: 'PUT',
    data: sysRole
  })
}
export const updateRoleV2 = (sysRole) => {
  return request({
    url: env.ferryUrl + '/role/v2/update',
    method: 'POST',
    data: sysRole
  })
}

/**
 * 删除角色
 */
export const deleteRoleById = (id) => {
  return request({
    url: env.ferryUrl + `/role/delById/${id}`,
    method: 'DELETE'
  })
}

/**
 * 分页查询角色
 */
export const getRolePage = (param) => {
  return request({
    url: env.ferryUrl + '/role/getPage',
    method: 'POST',
    data: param
  })
}

/**
 * 通过Id查询角色列表
 */
export const getRoleInfoById = (id) => {
  return request({
    url: env.ferryUrl + `/role/${id}`,
    method: 'GET'
  })
}

/**
 * 获取角色下拉列表
 */
export const getRoleListForSelect = () => {
  return request({
    url: env.ferryUrl + '/role/list',
    method: 'GET'
  })
}

/**
 * 获取角色权限树形列表
 */
export const getRoleAuthorityTree = (lazy, parentId) => {
  return request({
    url: env.ferryUrl + '/menu/treeAll',
    method: 'GET',
    params: {
      lazy,
      parentId
    }
  })
}

/**
 * 角色设置权限
 */
export const roleSetAuthority = (permissionsSet) => {
  return request({
    url: env.ferryUrl + '/role/permissionsSet',
    method: 'POST',
    data: permissionsSet
  })
}

/**
 * 根据角色id获取权限集合
 */
export const getPermissionByRoleId = (roleId) => {
  return request({
    url: env.ferryUrl + `/role/MenuList/${roleId}`,
    method: 'GET'
  })
}

/**
 * 复制角色
 */
export const copyRole = (roleId) => {
  return request({
    url: env.ferryUrl + `/role/copyRole/${roleId}`,
    method: 'GET'
  })
}
